export const setElementStyle = (element: HTMLElement, style: Record<string, string>) => {
    let cssText = ''
    Object.entries(style).forEach(([prop, value]) => {
        cssText += `${prop}:${value};`
    })
    element.style.cssText = cssText
}
